export const iconFontAwesomeMedicalHealthHeadSideMask = (
	<i className="fa-solid fa-head-side-mask"></i>
);
